import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sevices-boat',
  templateUrl: './sevices-boat.component.html',
  styleUrls: ['./sevices-boat.component.css']
})
export class SevicesBoatComponent {
  @Input() boatId: number | null = null ;// To receive boat ID from the parent component
  @Input() boatSlug: string | undefined; // Tambahkan input untuk slug
  @Input() boatServices: any | []; 
  isAccordionServicesOpen: boolean[] = [];

  toggleAccordion(index: number): void {
    // Membalikkan status panel tertentu
    this.isAccordionServicesOpen[index] = !this.isAccordionServicesOpen[index];
  } 
}
